import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '../../../../ThemeContext';

const StyledTabs = ({ 
  tabs = [], 
  value = 0, 
  onChange,
  fullWidth = true,
  variant = 'default' // 'default' or 'pills'
}) => {
  const { themeMode, currentTheme } = useTheme();

  const TabsContainer = styled(Box)({
    display: 'flex',
    width: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: themeMode === 'dark' ? '#3e3c56' : currentTheme.callAutomationPage.automationTypeColor,
    marginBottom: '12px'
  });
  
  const TabButton = styled(ButtonBase)(({ active }) => ({
    flex: 1,
    padding: '8px 12px',
    color: themeMode === 'dark' ? '#ffffff' : currentTheme.callAutomationPage.textColor,
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'center',
    backgroundColor: active ? '#ff4e3a' : 'transparent',
    transition: 'background-color 0.3s ease',
    height: '34px',
    '&:hover': {
      backgroundColor: active ? '#ff4e3a' : themeMode === 'dark' ? '#484860' : '#e8e8e8'
    }
  }));

  return (
    <TabsContainer sx={{ 
      maxWidth: fullWidth ? '100%' : '400px',
      ...(variant === 'pills' && {
        padding: '4px',
        backgroundColor: themeMode === 'dark' ? '#484860' : '#e8e8e8',
        borderRadius: '10px'
      })
    }}>
      {tabs.map((tab, index) => (
        <TabButton
          key={index}
          active={value === index}
          onClick={() => onChange(index)}
          sx={{
            ...(variant === 'pills' && {
              borderRadius: '6px',
              margin: '0 2px'
            })
          }}
        >
          {tab}
        </TabButton>
      ))}
    </TabsContainer>
  );
};

export default StyledTabs; 